import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import Modal from "../../components/shared/Modal/Modal";
import { useTranslation } from "react-i18next";
import { ServiceNextProject } from "../../services/ServiceNextProject";
import { Loading } from "../../components/shared";
import Selector, { SelectorType } from "../../components/shared/Selector/Selector";
import NextProjectPlacementSelector from "./NextProjectPlacementSelector";

type Props = {
  show: boolean,
  setShow: Dispatch<SetStateAction<boolean>>,
  projectId: string | null,
  onSuccess: (response: any) => void,
  onError: (error: any) => void,
  allNextProjects: any[],
  fetchAllNextProjects: () => void,
}

const ExportNextProjectModal: FC<Props> = ({ show, setShow, projectId, onSuccess, onError, allNextProjects, fetchAllNextProjects }) => {
  const [t] = useTranslation('projects');
  const [selectedParentProject, setSelectedParentProject] = useState<SelectorType>(null);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (show && allNextProjects.length == 0) {
      fetchAllNextProjects();
    }
  }, [show]);

  const handleExport = async () => {
    if (!projectId || !selectedParentProject) return;
    setExporting(true);
    try {
      const response = await ServiceNextProject.exportProject(projectId, Number(selectedParentProject.value));
      onSuccess(response);
      setShow(false);
    } catch (error) {
      onError(error);
    }
    setExporting(false);
  };

  return (
    <Modal
      title={t('exportNextProjectModal.headline', 'Skicka till Next Project')}
      show={show}
      setShow={setShow}
      buttonInfo={{
        label: t('exportNextProjectModal.button.send', 'Skicka'),
        action: handleExport,
        disabled: !selectedParentProject || exporting,
        loaderShow: exporting,
      }}
    >
      <NextProjectPlacementSelector 
        t={t}
        value={selectedParentProject} 
        onChange={setSelectedParentProject} 
        allNextProjects={allNextProjects}
        fetchAllNextProjects={fetchAllNextProjects}
      />      
    </Modal>
  );
};

export default ExportNextProjectModal;
